import moment from 'moment'
import taskStatuses from './taskStatuses'
import roles from './userRoles'

moment.locale('ru')

const columns = [
  {
    name: 'home.number',
    fieldName: 'ctid',
    sortName: 'ctid',
    width: 60
  },
  {
    name: 'home.task_name',
    fieldName: 'taskName',
    sortName: 'taskName',
    width: 150
  },
  {
    name: 'home.client',
    fieldName: 'client',
    sortName: 'client',
    width: 120
  },
  {
    name: 'home.manager',
    fieldName: 'manager',
    sortName: 'manager',
    width: 120
  },
  {
    name: 'home.designer',
    fieldName: 'designer',
    sortName: 'designer',
    width: 120
  },
  {
    name: 'home.printer',
    fieldName: 'printer',
    sortName: 'printer',
    width: 120
  },
  {
    name: 'home.after_printer',
    fieldName: 'afterPrinter',
    sortName: 'afterPrinter',
    width: 120
  },
  {
    name: 'home.create_date',
    fieldName: 'startDate',
    sortName: 'startDate',
    width: 75,
    enableFor: [roles.manager, roles.director, roles.master],
    filterName: 'all'
  },
  {
    name: 'home.getting_date',
    fieldName: 'designerStartDate',
    sortName: 'startDate',
    width: 75,
    enableFor: [roles.designer],
    filterName: 'design'
  },
  {
    name: 'home.getting_date',
    fieldName: 'printerStartDate',
    sortName: 'startDate',
    width: 75,
    enableFor: [roles.printer],
    filterName: 'print'
  },
  {
    name: 'home.getting_date',
    fieldName: 'afterPrinterStartDate',
    sortName: 'startDate',
    width: 75,
    enableFor: [roles.afterPrinter],
    filterName: 'afterPrint'
  },
  {
    name: 'home.return_date',
    fieldName: 'endDate',
    sortName: 'endDate',
    width: 75
  }
]

const adAgentTaskColumns = [
  {
    name: 'home.number',
    fieldName: 'ctid',
    sortName: 'ctid',
    width: 60
  },
  {
    name: 'home.task_name',
    fieldName: 'taskName',
    sortName: 'taskName',
    width: 150
  },
  {
    name: 'home.manager',
    fieldName: 'manager',
    sortName: 'manager',
    width: 120
  },
  {
    name: 'home.designer',
    fieldName: 'adAgentDesigner',
    sortName: 'adAgentDesigner',
    width: 120
  },
  {
    name: 'home.printer',
    fieldName: 'adAgentPrinter',
    sortName: 'adAgentPrinter',
    width: 120
  },
  {
    name: 'home.after_printer',
    fieldName: 'adAgentAfterPrinter',
    sortName: 'adAgentAfterPrinter',
    width: 120
  },
  {
    name: 'home.create_date',
    fieldName: 'startDate',
    sortName: 'startDate',
    width: 75,
    filterName: 'all'
  },
  {
    name: 'home.return_date',
    fieldName: 'endDate',
    sortName: 'endDate',
    width: 75
  }
]

const requestColumns = [
  {
    name: 'home.number',
    fieldName: 'ctid',
    sortName: 'ctid',
    width: 60
  },
  {
    name: 'home.task_name',
    fieldName: 'name',
    sortName: 'name',
    width: 100
  },
  {
    name: 'home.client',
    fieldName: 'client',
    sortName: 'client',
    width: 100
  },
  {
    name: 'home.create_date',
    fieldName: 'startDate',
    sortName: 'startDate',
    width: 75,
    filterName: 'all'
  },
  {
    name: 'home.return_date',
    fieldName: 'endDate',
    sortName: 'endDate',
    width: 75
  }
]

function getCell (rowData, fieldName, sortName) {
  const cell = {}
  switch (fieldName) {
    case 'ctid':
      cell.value = rowData.ctid
      cell.title = rowData.ctid
      cell.countNotReadComments = rowData.countNotReadComments
      cell.sortValue = rowData.ctid ? +rowData.ctid.toString().replace('A', '').replace('E', '') : ''
      cell.cssClass = 'task-number'
      break
    case 'local_id':
      cell.value = rowData.local_id
      cell.title = rowData.local_id
      cell.sortValue = rowData.local_id.replace('AA', '')
      cell.cssClass = 'task-number'
      break
    case 'taskName':
      cell.value = rowData.name
      cell.title = rowData.name
      cell.sortValue = rowData.name
      break
    case 'name':
      cell.value = rowData.name
      cell.title = rowData.name
      cell.sortValue = rowData.name
      break
    case 'client': {
      const clientName = rowData.client
        ? (rowData.client.legal_entity
          ? rowData.client.legal_entity.name
          : rowData.client.name)
        : rowData.client_name
          ? rowData.client_name
          : '-'
      cell.value = clientName
      cell.title = clientName
      cell.sortValue = clientName
      break
    }
    case 'manager': {
      const managerName = `${rowData.manager.user.firstname} ${
        rowData.manager.user.lastname
      }`
      cell.value = managerName
      cell.title = managerName
      cell.sortValue = managerName
      break }
    case 'designer': {
      const designerName = rowData.designer.user
        ? `${rowData.designer.user.firstname} ${rowData.designer.user.lastname}`
        : '-'
      const designStatus = taskStatuses.find(
        x => x.id === (rowData.designer.status.id || +rowData.designer.status)
      )
      cell.value = designerName
      cell.title = designerName
      cell.sortValue = rowData.designer ? designerName : null
      cell.cssClass = designStatus ? designStatus.className : ''
      break
    }
    case 'adAgentDesigner': {
      const designStatus = taskStatuses.find(
        x => x.id === (rowData.designer.status.id || +rowData.designer.status)
      )
      cell.value = ''
      cell.title = ''
      cell.sortValue = designStatus
      cell.cssClass = designStatus ? designStatus.className : ''
      break
    }
    case 'printer': {
      const printerName = rowData.printer.user
        ? `${rowData.printer.user.firstname} ${rowData.printer.user.lastname}`
        : '-'
      const printerStatus = taskStatuses.find(
        x => x.id === (rowData.printer.status.id || +rowData.printer.status)
      )
      cell.value = printerName
      cell.title = printerName
      cell.sortValue = rowData.printer ? printerName : null
      cell.cssClass = printerStatus ? printerStatus.className : ''
      break
    }
    case 'adAgentPrinter': {
      const printerStatus = taskStatuses.find(
        x => x.id === (rowData.printer.status.id || +rowData.printer.status)
      )
      cell.value = ''
      cell.title = ''
      cell.sortValue = printerStatus
      cell.cssClass = printerStatus ? printerStatus.className : ''
      break
    }
    case 'afterPrinter': {
      const afterPrinterName = rowData.after_printer.user
        ? `${rowData.after_printer.user.firstname} ${
            rowData.after_printer.user.lastname
          }`
        : '-'
      const afterPrinterStatus = taskStatuses.find(
        x => x.id === (+rowData.after_printer.status.id || +rowData.after_printer.status)
      )
      cell.value = afterPrinterName
      cell.title = afterPrinterName
      cell.sortValue = rowData.after_printer ? afterPrinterName : null
      cell.cssClass = afterPrinterStatus ? afterPrinterStatus.className : ''
      break
    }
    case 'adAgentAfterPrinter': {
      const afterPrinterStatus = taskStatuses.find(
        x => x.id === (rowData.after_printer.status.id || +rowData.after_printer.status)
      )
      cell.value = ''
      cell.title = ''
      cell.sortValue = afterPrinterStatus
      cell.cssClass = afterPrinterStatus ? afterPrinterStatus.className : ''
      break
    }
    case 'startDate': {
      const startDate = new Date(rowData.start_time)
      const startDateStr = moment(startDate).format('DD MMM YYYY HH:mm')
      cell.value = startDateStr
      cell.title = startDateStr
      cell.sortValue = startDate
      break
    }
    case 'designerStartDate': {
      const designerStartDate = rowData.designer.start_time
        ? new Date(rowData.designer.start_time)
        : null
      const designerStartDateStr = designerStartDate
        ? moment(designerStartDate).format('DD MMM YYYY HH:mm')
        : '-'
      cell.value = designerStartDateStr
      cell.title = designerStartDateStr
      cell.sortValue = designerStartDate
      break
    }
    case 'printerStartDate': {
      const printerStartDate = rowData.printer.start_time
        ? new Date(rowData.printer.start_time)
        : null
      const printerStartDateStr = printerStartDate
        ? moment(printerStartDate).format('DD MMM YYYY HH:mm')
        : '-'
      cell.value = printerStartDateStr
      cell.title = printerStartDateStr
      cell.sortValue = printerStartDate
      break
    }
    case 'afterPrinterStartDate': {
      const afterPrinterStartDate = rowData.after_printer.start_time
        ? new Date(rowData.after_printer.start_time)
        : null
      const afterPrinterStartDateStr = afterPrinterStartDate
        ? moment(afterPrinterStartDate).format('DD MMM YYYY HH:mm')
        : '-'
      cell.value = afterPrinterStartDateStr
      cell.title = afterPrinterStartDateStr
      cell.sortValue = afterPrinterStartDate
      break
    }
    case 'endDate': {
      const endDate = rowData.end_time ? new Date(rowData.end_time) : null
      const endDateStr = endDate
        ? moment(endDate).format('DD MMM YYYY HH:mm')
        : '-'
      cell.value = endDateStr
      cell.title = endDateStr
      cell.sortValue = endDate
      break
    }
  }

  return {
    value: cell.value,
    title: cell.title,
    countNotReadComments: cell.countNotReadComments,
    sortValue: cell.sortValue,
    fieldName: fieldName,
    sortName: sortName,
    cellClasses: cell.cssClass || ''
  }
}

const tableHelper = {
  getColumns: function (userRole, filterName) {
    const result = []
    columns.forEach(x => {
      if (
        (filterName && (!x.filterName || x.filterName === filterName)) ||
        (!filterName && (!x.enableFor || x.enableFor.some(y => y === userRole)))
      ) {
        result.push(x)
      }
    })
    return result
  },
  getAdAgentTasksColumns () {
    return adAgentTaskColumns
  },
  getAdAgentRequestColumns () {
    return adAgentTaskColumns.filter(x => x.fieldName !== 'client')
  },
  getRequestColumns (isAdAgent) {
    if (isAdAgent) {
      return requestColumns.filter(x => x.fieldName !== 'client')
    }

    return requestColumns
  },
  getRow: function (data, columns) {
    const result = {}
    const cells = []
    columns.forEach(function (col, index) {
      const cell = getCell(data, col.fieldName, col.sortName)
      cell.id = `${index}${data.taskId}`
      cells.push(cell)
    })

    result.cells = cells
    result.taskId = data.id
    result.overdue =
      new Date(data.end_time) < new Date() && data.status.name !== 'finished'
    result.hot = data.hot && data.status.name !== 'finished'
    return result
  },
  getArchiveRow: function (data, columns) {
    const result = {}
    const cells = []
    columns.forEach(function (col, index) {
      const cell = getCell(data, col.fieldName, col.sortName)
      cell.id = `${index}${data.taskId}`
      cells.push(cell)
    })

    result.cells = cells
    result.taskId = data.id
    return result
  },
  getRequestRow: function (data, columns) {
    const result = {}
    const cells = []
    columns.forEach(function (col, index) {
      const cell = getCell(data, col.fieldName, col.sortName)
      cell.id = `${index}${data.id}`
      cells.push(cell)
    })

    result.cells = cells
    result.taskId = data.id
    return result
  }
}

export default tableHelper
